export enum SurveyStatusEnum {
    None = 0,
    NotStarted = 1,
    InProgress = 2,
    Completed = 3,
    Rejected = 4,
    New = 5,
    LetterGeneration = 6,
    LetterSent = 7,
    Error = 8,
    CompletedWithWarnings = 9
}
